var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 2H1.5C0.671562 2 0 2.67156 0 3.5V12.5C0 13.3284 0.671562 14 1.5 14H14.5C15.3284 14 16 13.3284 16 12.5V3.5C16 2.67156 15.3284 2 14.5 2ZM14.3125 12.5H1.6875C1.63777 12.5 1.59008 12.4802 1.55492 12.4451C1.51975 12.4099 1.5 12.3622 1.5 12.3125V3.6875C1.5 3.63777 1.51975 3.59008 1.55492 3.55492C1.59008 3.51975 1.63777 3.5 1.6875 3.5H14.3125C14.3622 3.5 14.4099 3.51975 14.4451 3.55492C14.4802 3.59008 14.5 3.63777 14.5 3.6875V12.3125C14.5 12.3622 14.4802 12.4099 14.4451 12.4451C14.4099 12.4802 14.3622 12.5 14.3125 12.5ZM4 4.75C3.30966 4.75 2.75 5.30966 2.75 6C2.75 6.69034 3.30966 7.25 4 7.25C4.69034 7.25 5.25 6.69034 5.25 6C5.25 5.30966 4.69034 4.75 4 4.75ZM3 11H13V8.5L10.2652 5.76516C10.1187 5.61872 9.88128 5.61872 9.73481 5.76516L6 9.5L4.76516 8.26516C4.61872 8.11872 4.38128 8.11872 4.23481 8.26516L3 9.5V11Z",
    fill: "#537089"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictureIcon);
export default __webpack_public_path__ + "static/media/picture-icon.c5b9ccefaa62c8d8d52a6c5c5bc8830a.svg";
export { ForwardRef as ReactComponent };